import prismicStoresEn from '../../prismic-stores-data-EN.json';
import prismicStoresFr from '../../prismic-stores-data-FR.json';

const mecLocation = {
  '1': 'Vancouver',
  '2': 'Calgary',
  '3': 'Toronto',
  '4': 'Ottawa',
  '5': 'Edmonton',
  '6': 'Halifax',
  '7': 'Winnipeg',
  '8': 'Web Store',
  '9': 'Order Sales Location',
  '10': 'Corporate & Group Sales',
  '11': 'Montreal',
  '12': 'Quebec',
  '13': 'North Vancouver',
  '14': 'Victoria',
  '15': 'Burlington',
  '16': 'Longueuil',
  '17': 'Barrie',
  '18': 'London',
  '19': 'Langley',
  '20': 'St. Denis',
  '21': 'North York',
  '22': 'Kelowna',
  '23': 'Laval',
  '24': 'South Edmonton',
  '25': 'Kitchener',
  '26': 'Calgary South',
  '27': 'Calgary West',
  '28': 'Saskatoon',
  '17001': 'Moncton',
  '14014': 'Whitby',
};

const hbc = {
  '29': 'HBC-Eaton Centre',
  '30': 'HBC-Square One',
  '31': 'HBC-Yorkdale',
  '32': 'HBC-ON4', // TODO we might want to update these names as these could get used in Algolia's UI etc if Prismic fails
  '33': 'HBC-ON5',
  '34': 'HBC-ON6',
  '35': 'HBC-QC1',
  '36': 'HBC-QC2',
  '37': 'HBC-QC3',
};

const defaultStoreList = {
  ...mecLocation,
};

// Declared explicitly rather than derived from `(typeof prismicStoresEn)[number]`:
// that derivation collapses to `never` when the gitignored
// prismic-stores-data-*.json files are stubbed as `[]` (as CI does), which
// would make every field access and Record<StoreId, StoreName> below fail to
// type-check.
type PrismicStore = {
  data: {
    exclude_from_spu?: boolean;
    mec_store_id: string;
    store_name: string;
  };
};

type StoreId = string;
type StoreName = string;

type StoreDictionary = {
  activeSPU: Record<StoreId, StoreName>;
  disabledSPU: Record<StoreId, StoreName>;
};

export const getStoreDictionary = (locale?: string) => {
  try {
    const dictionaryReducer = (dict: StoreDictionary, store: PrismicStore) => {
      if (store.data.exclude_from_spu) {
        return {
          ...dict,
          disabledSPU: {
            ...dict.disabledSPU,
            [store.data.mec_store_id]: store.data.store_name,
          },
        };
      }
      return {
        ...dict,
        activeSPU: {
          ...dict.activeSPU,
          [store.data.mec_store_id]: store.data.store_name,
        },
      };
    };

    let dictionary: StoreDictionary;

    if (locale === 'fr') {
      dictionary = prismicStoresFr.reduce<StoreDictionary>(dictionaryReducer, {
        activeSPU: {},
        disabledSPU: {},
      });
    } else {
      dictionary = prismicStoresEn.reduce<StoreDictionary>(dictionaryReducer, {
        activeSPU: {},
        disabledSPU: {},
      });
    }

    return dictionary;
  } catch (error) {
    console.error(`error fetching prismic mecLocationFromJSON: ${error}`);
    return {
      activeSPU: defaultStoreList,
      disabledSPU: {},
    } as StoreDictionary;
  }
};
